import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { xCircleIcon, homeIcon as homeIconSvg } from '@progress/kendo-svg-icons';
import { ButtonsComponentsModule } from '../buttons/buttons.module';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, ButtonsModule, IconsModule, ButtonsComponentsModule],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  private location = inject(Location);
  private router = inject(Router);

  errorIcon = xCircleIcon;
  homeIcon = homeIconSvg;

  goBack(): void {
    this.location.back();
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
